var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowShelf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "058e22af-b32b-4768-affa-8b695231f9a6",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215,
    height: 140,
    viewBox: "0 0 215 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "00ed74fb-8fad-4e48-aaf7-3d17d46979ee",
    y1: 60.83,
    x2: 215,
    y2: 60.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#3dbfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ff9a"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LowShelf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 140,
    transform: "translate(215 140) rotate(-180)",
    style: {
      fill: "#262728"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 140 215 140 215 68 75 68 54.73 56.94 41.25 53.67 0 53.67 0 68 0 140",
    style: {
      fill: "#fff",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.57,68H80.91C70.24,68,57.24,82.33,40.24,82.33H.43",
    style: {
      fill: "none",
      stroke: "#7f8992",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,68H80.8C70.09,68,57,53.67,40,53.67H0",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#00ed74fb-8fad-4e48-aaf7-3d17d46979ee)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowShelf);
export default __webpack_public_path__ + "static/media/LowShelf.d8cc8d1e.svg";
export { ForwardRef as ReactComponent };